import { promiseWithAbortCtrl } from 'core/utils';
import type { NodeWithMenu, ContextMenuItems, GetContextMenuItems } from './types';

type ReturnNormalizeContextItems = {
  promise: Promise<ContextMenuItems>;
  cancel: () => void;
};

export const normalizeContextItems = <TNode extends NodeWithMenu>(
  contextMenuItemsOrFunction: GetContextMenuItems<TNode>,
  node?: TNode,
): ReturnNormalizeContextItems => {
  const abortCtrl = new AbortController();
  const cancel = () => {
    abortCtrl.abort('Cancelled');
  };

  if (!contextMenuItemsOrFunction) {
    return {
      promise: promiseWithAbortCtrl<ContextMenuItems>([], abortCtrl.signal),
      cancel,
    };
  }

  if (typeof contextMenuItemsOrFunction === 'function') {
    return {
      promise: promiseWithAbortCtrl<ContextMenuItems | Promise<ContextMenuItems>>(
        contextMenuItemsOrFunction(node),
        abortCtrl.signal,
      ),
      cancel,
    };
  }

  return {
    promise: promiseWithAbortCtrl<ContextMenuItems | Promise<ContextMenuItems>>(
      contextMenuItemsOrFunction,
      abortCtrl.signal,
    ),
    cancel,
  };
};
